import { debounce, delay, get, isEmpty, size } from 'lodash-es';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CustomSelect from '../../components/CustomSelect';
import { genderMapValues } from '../../utils/common';
import { appointmentSegmentAnalytics } from '../Appointment/segment';
class ThearapistFilter extends Component {
  constructor(props) {
    super(props);
    this.state = this.getDefaultState();
    this.genderSelected = this.genderSelected.bind(this);
    this.pregnancyToggle = this.pregnancyToggle.bind(this);
    this.locationSelected = this.locationSelected.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.updateSearchVal = debounce(this.updateSearchVal, 350);
  }

  getDefaultState = () => ({
    gender: [],
    pregnancyPreference: null,
    searchVal: '',
    selectedLocations: [],
  });

  genderSelected(val) {
    const filterState = get(this.props, 'appointmentData.filterState');

    if (filterState) {
      this.props.setFilterState({
        ...filterState,
        gender: size(val) > 1 || isEmpty(val) ? 'either' : genderMapValues[val],
      });
      delay(() => {
        appointmentSegmentAnalytics(
          'Filter by Gender',
          { ...this.props },
          ['Category', 'Logged_In', 'Gender_Preference'],
          'page',
        );
      }, 50);
    }

    this.setState(
      {
        gender: size(val) > 1 || isEmpty(val) ? [] : genderMapValues[val],
      },
      () => this.props.handleFilter({ ...this.state }),
    );
  }

  pregnancyToggle(val) {
    this.setState({ pregnancyPreference: val }, () =>
      this.props.handleFilter({ ...this.state }),
    );
  }

  locationSelected(val) {
    this.setState({ selectedLocations: val }, () =>
      this.props.handleFilter({ ...this.state }),
    );
  }

  handleSearch(e) {
    this.updateSearchVal(e.target.value);
  }

  updateSearchVal(searchVal) {
    this.setState({ searchVal }, () =>
      this.props.handleFilter({ ...this.state }),
    );
  }

  render() {
    const { pregnancyToggle, locations } = this.props;
    return (
      <div className="t-squeezer__toolbar bottomMarginZero subhdr-stripes t-squeezerNopadNomar">
        <div className="t-squeezer__dropdowns">
          {!isEmpty(locations) &&
            locations.length > 1 && (
              <div className="t-squeezer__col">
                <CustomSelect
                  name="Locations "
                  onChange={this.locationSelected}
                  options={[...locations]}
                  isSingleSelect={false}
                />
              </div>
            )}

          <div className="t-squeezer__col">
            <CustomSelect
              name="Gender"
              onChange={this.genderSelected}
              options={[{ id: '0', name: 'MALE' }, { id: '1', name: 'FEMALE' }]}
              multiSelect={false}
              isSingleSelect
            />
          </div>
          <div className="t-squeezer__col">
            {!isEmpty(pregnancyToggle) && (
              <CustomSelect
                name="Are you pregnant?"
                onChange={this.pregnancyToggle}
                options={[...pregnancyToggle]}
                multiSelect={false}
                isSingleSelect
              />
            )}
          </div>
        </div>
        <div className="position__search phone-only mob-franchise">
          <div className="subhdr-stripes subhdr-stripes--ucase mobileBackStrippedText">
            <div className="t-squeezer__col-lrg t-squeezer__search">
              <div className="input-default">
                <i className="icon icon--search" />
                <input
                  id="filtersSearch"
                  placeholder="Search Therapists"
                  className="input bg-white"
                  onChange={this.handleSearch}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="t-squeezer__col-lrg t-squeezer__search hide-phone franchise-desk">
          <div className="input-default">
            <i className="icon icon--search" />
            <input
              id="filtersSearch"
              placeholder="Search Therapists"
              className="input bg-white"
              onChange={this.handleSearch}
            />
          </div>
        </div>
      </div>
    );
  }
}

ThearapistFilter.propTypes = {
  handleFilter: PropTypes.func,
  locations: PropTypes.array,
  setFilterState: PropTypes.func,
  pregnancyToggle: PropTypes.array,
};

export default ThearapistFilter;
